import { registerSectionType } from "../../utils/sectionRegistry";
import { renderCtaButton } from "../sectionHelpers";
import { FALLBACK_IMAGE } from "../../../../utils/uiConstants";
import { resolveImageUrl } from "../../../../utils/imageUtils";

registerSectionType({
  type: "portada",
  label: "Portada con imagen",
  layout: "split",
  previewBlocks: ["Imagen portada", "Titulo + texto"],
  getDefaults: () => ({ type: "portada", title: "", subtitle: "", description: "", backgroundImage: FALLBACK_IMAGE }),
  render: (section, index) => {
    const hasOverlayContent = section?.title || section?.subtitle || section?.description || section?.button?.label;
    const imageSrc = resolveImageUrl(section?.image?.src || section?.backgroundImage);
    return (
      <section
        key={`cover-${index}`}
        className="dynamic-cover-hero"
        style={imageSrc ? { backgroundImage: `url(${imageSrc})` } : undefined}
      >
        {hasOverlayContent ? (
          <div className="dynamic-cover-overlay">
            {section?.title ? <h1>{section.title}</h1> : null}
            {section?.subtitle ? <p className="dynamic-subtitle">{section.subtitle}</p> : null}
            {section?.description ? <p className="dynamic-description">{section.description}</p> : null}
            {renderCtaButton(section?.button)}
          </div>
        ) : null}
      </section>
    );
  },
});
